import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as tagWidgetActions from './tagWidgetActions';

export type TagWidgetAction = ActionType<typeof tagWidgetActions>;

export interface ITagWidgetStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: ITagType };
	readonly queries: { [queryKey: string]: ITagType[] };
}

export function tagWidgetReducer(
	state = baseInitialState as ITagWidgetStateType,
	action: TagWidgetAction,
) {
	const Reducer = new BaseReducer('tagWidgetReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
